<template>
  <sgwg-content width="548" heigth="640">


    <v-list-item two-line class="align-center">

      <sg-widget-icon height="48" width="48" class="mr-3" />

      <v-list-item-content>
        <v-list-item-title class="headline">Оплата услуг</v-list-item-title>
        <v-list-item-subtitle>{{address}}</v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action v-if="!wgStandAlone">
        <v-btn icon @click.stop="close" large>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-list-item-action>

    </v-list-item>

    <sgwg-payments :searchResult="searchResult" />
  </sgwg-content>
</template>

<script>
  import SgwgContent from '@/components/SgwgContent'
  import SgwgPayments from './SgwgPayments'

  import SgWidgetIcon from '@/components/SgWidgetIcon'

  export default {
    components: {
      SgwgContent,
      SgwgPayments,
      SgWidgetIcon
    },
    props: {
      searchResult: Object,
    },
    computed: {
      address() {
        return this.searchResult.address
      },
      wgStandAlone() {
        return !!this.$store.state.options && (this.$store.state.options.standAlone === true || this.$store.state.options.standAlone == "true")
      },
    },
    methods: {
      close() {
        this.$router.push({
          name: 'search'
        })
        this.postMessage('dialog:close')
      }
    }
  }
</script>

<style>

</style>